import React from 'react';
import { useTranslation } from 'react-i18next';
import { AutoHideScrollArea } from '@/components/AutoHideScrollArea';
import { EvaluationScaleTable } from '@/components/LessonDetailsModal/EvaluationScaleTable';
import { Modal } from '@/components/Modal';
import { useSwipeToClose } from '@/hooks/useSwipeToClose';
import { ModalVariant } from '@/types/components';
import type { TestEvaluationScaleItem } from '@/types/testReport';

interface Props {
  isOpen: boolean;
  items: TestEvaluationScaleItem[];
  onClose: () => void;
}

export const EvaluationScaleSheet: React.FC<Props> = ({
  isOpen,
  items,
  onClose,
}) => {
  const { t } = useTranslation();
  const { sheetRef, swipeProps } = useSwipeToClose(onClose);

  const title = t('diary.testReport.scale');

  return (
    <Modal
      isOpen={isOpen}
      label={title}
      variant={ModalVariant.BottomSheet}
      className="max-h-[90svh]!"
      contentRef={sheetRef}
      onClose={onClose}
    >
      <div
        {...swipeProps}
        className="flex shrink-0 cursor-grab touch-none flex-col active:cursor-grabbing"
      >
        <div className="flex justify-center py-2">
          <div className="h-[3px] w-10 rounded-full bg-drag-handle" />
        </div>
        <h2 className="text-title-36 px-4 py-3 text-foreground">{title}</h2>
      </div>

      <AutoHideScrollArea hasTopShadow className="flex min-h-0 flex-1 flex-col">
        <div className="px-4 pt-5 pb-[calc(24px+env(safe-area-inset-bottom))]">
          <EvaluationScaleTable items={items} />
        </div>
      </AutoHideScrollArea>
    </Modal>
  );
};
